import { Box } from '@mui/material';
import { Typography } from '@/primitives';
import { DEFAULT_CURRENCY_SYMBOL } from '@/lib/currency';
import {
  formatBreedAverageLine,
  isRedBreedAverageDisplayLine,
  parseBreedAverageStyledLines,
  resolveBreedAverageLineDisplayColor,
} from './breedAverageDisplay';

type BreedAverageEbvCellProps = {
  raw: string | number | null | undefined;
  format?: string;
  currencySymbol?: string;
};

/** Renders society EBV_AVERAGE values, including ILR2 dual-line HTML. */
export default function BreedAverageEbvCell({
  raw,
  format = '0',
  currencySymbol = DEFAULT_CURRENCY_SYMBOL,
}: BreedAverageEbvCellProps) {
  const lines = parseBreedAverageStyledLines(raw);
  if (lines.length === 0) return <>—</>;

  if (lines.length === 1) {
    const firstLine = lines[0];
    if (!firstLine?.text) return <>—</>;
    return (
      <Typography variant="bodysmall" component="span">
        {formatBreedAverageLine(firstLine.text, format, currencySymbol)}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
        lineHeight: 1.15,
      }}
    >
      {lines.map((line, i) => {
        const isRedLine = isRedBreedAverageDisplayLine(line.color, i);
        return (
          <Typography
            key={i}
            variant="bodysmall"
            component="span"
            className={isRedLine ? 'public-search-ebv-red-avg' : undefined}
            sx={{
              color: resolveBreedAverageLineDisplayColor(line.color, i),
            }}
          >
            {formatBreedAverageLine(line.text, format, currencySymbol)}
          </Typography>
        );
      })}
    </Box>
  );
}
